@if (apError) {
    <ap-error [apError]="apError"> </ap-error>
}
